export default __webpack_public_path__ + "static/media/modal-close.3958c9d0.svg";